<script setup lang="ts">
const device = useDevice();

const props = withDefaults(
    defineProps<{ position?: 'bottom' | 'top' }>(),
    { position: 'bottom' }
);

const isOpen = ref(false);
const rootRef = useTemplateRef('rootRef');

function toggle() {
    if (device.isDesktop.value) return;
    isOpen.value = !isOpen.value
};

function close() {
    if (device.isDesktop.value) return;
    isOpen.value = false
};

onClickOutside(rootRef, () => {
    if (!rootRef.value || device.isDesktop.value) return;
    close();
});
</script>

<template>
    <div
        ref="rootRef"
        class="relative flex-center group"
        @click="toggle"
    >
        <slot 
            name="activator" 
            :open="isOpen" 
            :toggle="toggle" 
        />

        <div
            class="absolute z-100 flex-center opacity-0 invisible transition-opacity group-hover:opacity-100 group-hover:visible
                before:content-[''] before:absolute before:w-4 before:h-4 before:rotate-45 before:bg-white
                before:shadow-gray-l before:border before:border-secondary-100"
            :class="[
                isOpen && 'opacity-100! visible!',
                position === 'top'
                    ? 'bottom-10 before:-bottom-2'
                    : 'top-10 before:-top-2',
            ]"
        >
            <div class="rounded-lg border border-secondary-100 shadow-gray-l overflow-hidden">
                <slot />
            </div>
        </div>
    </div>
</template>